import {
    reactive
} from 'vue'

export const qrcodeCameraStatus = reactive({
    html5QrcodeScanner: '',
})